// extracted by mini-css-extract-plugin
export default {"box_game":"FavoriteItem_box_game__aULsg","favorites":"FavoriteItem_favorites__W4rby","game":"FavoriteItem_game__CbODm","btn_delete":"FavoriteItem_btn_delete__Zzl6B"};